<template>
  <zm-scrollbar
    ref="scrollbar"
    :wrap-style="`max-height:${maxLine * 32 + 15}px;`"
    view-class="tag-list"
  >
    <zm-tag
      v-for="item in screenList"
      :key="item.id"
      :closable="!disabled"
      class="zm-tag-fix"
      :hit="true"
      :delete-text="t('tag.delete') + ' ' + item.name"
      type="info"
      size="small"
      disable-transitions
      @close="$emit('delete', item.id)"
    >
      <span class="zm-group-select__tags-text">{{ item.name }}</span>
    </zm-tag>
    <zm-tag
      v-if="selectedList.length > screenList.length"
      class="zm-tag-fix"
      :closable="false"
      type="info"
      size="small"
      disable-transitions
    >
      <span class="zm-group-select__tags-text">+ {{ selectedList.length - screenList.length }}
      </span>
    </zm-tag>
  </zm-scrollbar>
</template>

<script>
  // import find from 'lodash-es/find';
  import ZmTag from '../tag';
  import ZmScrollbar from '../scrollbar';
  import Locale from '../../mixins/locale';
  // function flattenArray(data, {nameKey, valueKey, childKey}, list, namePrefix) {
  //   list = list || [];
  //   (data || []).forEach(item => {
  //     const itemNamePrefix = (namePrefix ? namePrefix + ':' : '') + item[nameKey];
  //     list.push({
  //       name: itemNamePrefix,
  //       id: item[valueKey]
  //     })
  //     if (item[childKey]) {
  //       flattenArray(item[childKey], {nameKey, valueKey, childKey}, list, itemNamePrefix);
  //     }
  //   });
  //   return list;
  // }
  function createIdNamePrefixMap(data, {nameKey, valueKey, childKey}, map, namePrefix) {
    map = map || {};
    (data || []).forEach(item => {
      const itemNameWithPrefix = (namePrefix ? namePrefix + ' / ' : '') + item[nameKey];
      map[item[valueKey]] = itemNameWithPrefix;
      if (item[childKey]) {
        createIdNamePrefixMap(item[childKey], {nameKey, valueKey, childKey}, map, itemNameWithPrefix);
      }
    });
    return map;
  }
  export default {
    name: 'ZmMultiSelectScreenList',
    components: {
      ZmTag,
      ZmScrollbar
    },
    mixins: [Locale],
    props: {
      options: {
        type: Array,
        default() {
          return [];
        }
      },
      valueKey: {
        type: String,
        default: 'id'
      },
      nameKey: {
        type: String,
        default: 'label'
      },
      childKey: {
        type: String,
        default: 'children'
      },
      showAllLevels: {
        type: Boolean,
        default: true
      },
      disabled: Boolean,
      selectedList: {
        type: Array,
        default() {
          return [];
        }
      },
      collapseTags: Boolean,
      maxLine: {
        type: Number,
        default: 1
      }
    },
    data() {
      return {};
    },
    computed: {
      screenList() {
        let idNamePrefixMap = {};
        if (this.showAllLevels) {
          idNamePrefixMap = createIdNamePrefixMap(this.options, {
            nameKey: this.nameKey,
            valueKey: this.valueKey,
            childKey: this.childKey
          });
        }
        const createScreenItem = (item) => {
          const id = item[this.valueKey];
          return {
            id,
            name: idNamePrefixMap[id] || item[this.nameKey]
          };
        };
        if (this.collapseTags && this.selectedList.length) {
          return [createScreenItem(this.selectedList[0])];
        }
        return this.selectedList.map(item => createScreenItem(item));
      }
    }
  };
</script>
